import { projectManagementApi } from '@/includes/projectManagementApi';

const pmManagementService = {
  async getPortfolio() {
    const response = await projectManagementApi.get('/management/portfolio');
    return response.data;
  },

  async getDecisionFocus() {
    const response = await projectManagementApi.get('/management/decision-focus');
    return response.data;
  },
};

export default pmManagementService;
